import React from "react";
import './Ledger.scss'
import Header from "../HomeMain/Header/Header";

const Ledger = () => {
  return (
    <div>
      <Header />
      <div style={{ margin: "60px 5px 0px" }}>
        <table style={{ width: "100%", backgroundColor: "white" }}>
          <tr className="Leager_headerTable">
            <th>Date</th>
            <th>Perticulars</th>
            <th>DR/CR</th>
            <th>Acc Name</th>
          </tr>
          <tr className="ledger_tableRowMain">
            <td className="tableDate">21/11/24</td>
            <td>Chek form client</td>
            <td>dave</td>
            <td>Hello Sir</td>
          </tr>

          <tr className="ledger_tableRowMain">
            <td className="tableDate">21/11/24</td>
            <td>Chek form client</td>
            <td>dave</td>
            <td>Hello Sir</td>
          </tr>

          <tr className="ledger_tableRowMain">
            <td className="tableDate">21/11/24</td>
            <td>Chek form client</td>
            <td>dave</td>
            <td>Hello Sir</td>
          </tr>

          <tr className="ledger_tableRowMain">
            <td className="tableDate">21/11/24</td>
            <td>Chek form client</td>
            <td>dave</td>
            <td>Hello Sir</td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default Ledger;
